import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import "./style.css";

import { Spin, Table, Select } from "antd";
import { Trash2 } from "react-feather";
import { Link } from "react-router-dom";
// import { getAllEmployeesWithoutPaginationMethod } from '../../../service/ApiServices';
import { getAllLeaveTypes, getLeaveTypeById } from "../../../service/leaveApiServices/leaveTypesApi";
import { saveLeaveAllocations, filteredTableData } from "../../../service/leaveAllocationService";
import { getAllDepartments } from "../../../service/departmentService";
import { getAllEmployeesMethod } from "../../../service/ApiServices";

import { toast } from "react-toastify";

const CreateLeaveTypeModal = ({
  handleCancel,
  selectedLeaveType,
  handleLeaveTypeAdding
}) => {
  const [leaveCount, setLeaveCount] = useState("");
  const [loading, setLoading] = useState(false);
  const [employeeData, setEmployeeData] = useState([]);
  const [leaveTypeOptions, setleaveTypeOptions] = useState([]);
  const [departmentOptions, setDepartmentOptions] = useState([]);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [selectedLeaveTypeOption, setSelectedLeaveTypeOption] = useState(null);
  const [addedRows, setAddedRows] = useState([]);
  const [leaveAllocations, setLeaveAllocations] = useState([]);
  const [empType, setEmpType] = useState(null);
  const [selectedDepartment, setSelectedDepartment] = useState(null);
  const [epf_number, setEpf] = useState("");
  const currentYear = new Date().getFullYear();

  const employeeTypes = [
    { value: "Academic", label: "Academic" },
    { value: "Non Academic", label: "Non Academic" },
  ];

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        await getAllEmployeesMethod({
              setEmployeeData: (responseData) => {
                console.log('Employee API response:', responseData);
                const employeeData = responseData?.data || [];
                if (!Array.isArray(employeeData)) {
                  console.error('Employee data is not an array:', employeeData);
                  setEmployeeData([]);
                } else {
                  setEmployeeData(employeeData);
                }
              },
              setLoading,
              search: '',
              params: { page: 1, limit: 1000 },
            });
      } catch (error) {
        console.error('Error fetching data:', error);
        setEmployeeData([]);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  const handleChangeLeaveType = (value, option) => {
    setSelectedLeaveTypeOption(option);
  };

  const handleChangeEmployee = (value, option) => {
    setSelectedEmployee(option);
    if (option) {
      const emp = employeeData.find(e => e._id === value);
      if (emp) {
        setEmpType(emp.employee_type || null);
        const deptName = emp.department?.departmentName || emp.department;
        setSelectedDepartment(deptName ? { value: deptName, label: deptName } : null);
      }
    } else {
      setEmpType(null);
      setSelectedDepartment(null);
    }
  };

  const handleChangeDepartment = (value, option) => {
    setSelectedDepartment(option);
  };

  useEffect(() => {
    const fetchLeaveTypes = async () => {
      try {
        const response = await getAllLeaveTypes({ search: '', setLoading });
        const options = response.map(item => ({
          value: item._id,
          label: item.name
        }));
        setleaveTypeOptions(options);
        const department = await getAllDepartments({ search: "" });
        const dptOptions = department.map(item => ({
          value: item.departmentName,
          label: item.departmentName
        }));
        setDepartmentOptions(dptOptions);
      } catch (error) {
        console.error("Error in fetching Service Names", error);
      } finally {
        setLoading(false);
      }
    };
    fetchLeaveTypes();
  }, [setLoading]);

  const handleAddToTable = async () => {
    if (selectedEmployee) {
      if (!selectedEmployee || !selectedLeaveTypeOption || leaveCount === "") {
        toast.error("Please fill in all fields");
        return;
      }

      const isDuplicate = leaveAllocations.some(
        (allocation) =>
          (allocation.employee.value === selectedEmployee.value || allocation.employee._id === selectedEmployee.value) &&
          allocation.leaveType.value === selectedLeaveTypeOption.value
      );

      if (isDuplicate) {
        toast.error("This leave type is already allocated for the selected employee.");
        return;
      }

      const leaveCountNum = parseInt(leaveCount);
      if (isNaN(leaveCountNum) || leaveCountNum < 0) {
        toast.error("Leave count must be a valid non-negative number");
        return;
      }

      try {
        const leaveType = await getLeaveTypeById(selectedLeaveTypeOption.value);

        if (leaveCountNum > leaveType.quota) {
          toast.error(`Leave count exceeds the quota of ${leaveType.quota}`);
          return;
        }

        const emp = employeeData.find(e => e._id === selectedEmployee.value);
        const newRow = {
          employee: { ...selectedEmployee, epf_number: emp?.epf_number },
          leaveType: selectedLeaveTypeOption,
          leaveCount: leaveCountNum,
          initialQuota: leaveCountNum,
          checked: true
        };

        const obj = {
          employee: { ...selectedEmployee, epf_number: emp?.epf_number },
          leaveType: selectedLeaveTypeOption,
          leaveCount: leaveCountNum,
          initialQuota: leaveCountNum,
          checked: true
        };

        setLeaveAllocations([...leaveAllocations, obj]);
        setAddedRows([...addedRows, newRow]);
        handleAfterAddReset();
      } catch (error) {
        console.error("Error fetching leave type or adding to table:", error);
        toast.error("Failed to fetch leave type details or add data");
      }
    } else {
      if (!selectedLeaveTypeOption || leaveCount === "") {
        toast.error("Please fill in required fields");
        return;
      }

      const leaveCountNum = parseInt(leaveCount);
      if (isNaN(leaveCountNum) || leaveCountNum < 0) {
        toast.error("Leave count must be a valid non-negative number");
        return;
      }

      try {
        const tableData = await filteredTableData({
          epf_number,
          empType,
          departmentName: selectedDepartment?.value,
          leaveTypeId: selectedLeaveTypeOption?.value
        });

        // Check for duplicates in the fetched tableData against existing allocations
        // We filter out duplicates so we don't add them again, or we could block.
        // Given the requirement "System must prevent adding", blocking feels safer if the user intention is ambiguous,
        // but filtering avoids full blockage. Let's block if any duplicate is found to be consistent with the single-add message.
        
        const hasDuplicate = tableData.some(emp => 
          leaveAllocations.some(alloc => 
            (alloc.employee.value === emp._id || alloc.employee._id === emp._id) && 
            alloc.leaveType.value === selectedLeaveTypeOption.value
          )
        );

        if (hasDuplicate) {
             toast.error("This leave type is already allocated for one or more employees in the selection.");
             return;
        }

        const newRows = tableData.map(employee => ({
          employee,
          leaveType: selectedLeaveTypeOption,
          leaveCount: leaveCountNum,
          initialQuota: leaveCountNum,
          checked: true
        }));

        const newObj = tableData.map(employee => ({
          employee,
          leaveType: selectedLeaveTypeOption,
          leaveCount: leaveCountNum,
          initialQuota: leaveCountNum,
          checked: true
        }));

        setLeaveAllocations(prevState => [...prevState, ...newObj]);
        setAddedRows(prevState => [...prevState, ...newRows]);
        handleAfterAddReset();
      } catch (error) {
        console.error("Error fetching employee data:", error);
        toast.error("Failed to fetch employee data");
      }
    }
  };

  const handleDeleteRow = (index) => {
    const updatedRows = addedRows.filter((_, i) => i !== index);
    const updatedAllocations = leaveAllocations.filter((_, i) => i !== index);
    
    setAddedRows(updatedRows);
    setLeaveAllocations(updatedAllocations);
  };

  const handleSaveClick = async () => {
    if (leaveAllocations.length === 0) {
      if (selectedEmployee || selectedLeaveTypeOption || leaveCount) {
        toast.error("Please click the ‘Add’ button before clicking ‘Save’ to allocate the leave.");
      } else {
        toast.error("Please allocate leaves to save");
      }
      return;
    }

    try {
      const newLeavesAllocations = leaveAllocations.map(employee => ({
        employee: employee.employee.value,
        leaveBalances: [{
          leaveType: employee.leaveType.value,
          leaveCount: parseInt(employee.leaveCount),
          initialQuota: parseInt(employee.initialQuota)
        }],
        finacialYear: currentYear.toString(),
        financialYear: currentYear.toString()
      }));

      console.log('Preparing to save:', newLeavesAllocations); // Debug log

      const savedData = await saveLeaveAllocations(newLeavesAllocations, setLoading);
      setLeaveAllocations([]);
      setAddedRows([]);
      handleLeaveTypeAdding();
      console.log('Allocations saved:', savedData);
    } catch (error) {
      console.error('Save failed:', error.message);
       toast.error("Failed to save leave allocations");
    }
  };

  const editSaveClick = async () => {
    if (!selectedEmployee || !selectedLeaveTypeOption || leaveCount === "") {
      toast.error("Please fill in all fields");
      return;
    }

    const leaveCountNum = parseInt(leaveCount);
    if (isNaN(leaveCountNum) || leaveCountNum < 0) {
      toast.error("Leave count must be a valid non-negative number");
      return;
    }

    try {
      const leaveType = await getLeaveTypeById(selectedLeaveTypeOption.value);

      if (leaveCountNum > leaveType.quota) {
        toast.error(`Leave count exceeds the quota of ${leaveType.quota}`);
        return;
      }

      const obj = {
        employee: selectedEmployee.value,
        leaveBalances: [{
          leaveType: selectedLeaveTypeOption.value,
          leaveCount: leaveCountNum,
          initialQuota: leaveCountNum
        }],
        finacialYear: currentYear.toString(),
        financialYear: currentYear.toString()
      };

      const updatedLeaveAllocations = [...leaveAllocations, obj];

      console.log('Preparing to save (edit):', updatedLeaveAllocations); // Debug log

      const savedData = await saveLeaveAllocations(updatedLeaveAllocations, setLoading);
      handleLeaveTypeAdding();
      setLeaveAllocations([]);
      setSelectedEmployee(null);
      setSelectedLeaveTypeOption(null);
      setLeaveCount("");
      console.log('Allocations saved:', savedData);
    } catch (error) {
      console.error('Save failed:', error.message);
      toast.error("Failed to save leave allocations");
    }
  };

  const handleReset = () => {
    setSelectedEmployee(null);
    setSelectedLeaveTypeOption(null);
    setLeaveCount("");
    setEpf("");
    setSelectedDepartment(null);
    setEmpType(null);
  };

  const handleAfterAddReset = () => {
    setSelectedLeaveTypeOption(null);
    setLeaveCount("");
  };

  const handleClose = () => {
    setLeaveAllocations([]);
    setAddedRows([]);
    handleCancel();
    handleReset();
  };

  useEffect(() => {
    if (selectedLeaveType) {
      setSelectedEmployee({
        value: selectedLeaveType.employee._id,
        label: `${selectedLeaveType.employee.first_name} ${selectedLeaveType.employee.last_name}`,
      });
      const leaveBalance = selectedLeaveType.leaveBalances[0];
      setSelectedLeaveTypeOption({
        value: leaveBalance.leaveType._id,
        label: leaveBalance.leaveType.name,
      });
      setLeaveCount(leaveBalance.leaveCount.toString());
    }
  }, [selectedLeaveType]);

  const columns = [
    {
      title: 'Employee Name',
      dataIndex: 'employee',
      render: (employee) => employee?.full_name || employee?.label || "-",
    },
    {
      title: 'Epf No',
      dataIndex: 'employee',
      render: (employee) => employee?.epf_number || "-",
    },
    {
      title: 'Leave Type',
      dataIndex: 'leaveType',
      render: (leaveType) => leaveType?.label || "-",
    },
    {
      title: 'Initial Quota',
      dataIndex: 'initialQuota',
      key: 'initialQuota',
    },
    {
      title: 'Current Balance',
      dataIndex: 'leaveCount',
      key: 'leaveCount',
    },
    {
      title: 'Action',
      key: 'action',
      render: (_, record, index) => (
        <Link
          to="#"
          className="confirm-text"
          onClick={() => handleDeleteRow(index)}
        >
          <Trash2 className="feather-trash-2" />
        </Link>
      ),
    },
  ];

  return (
    <div className="modal-content">
      <div className="modal-header border-0 custom-modal-header">
        <div className="page-title">
          <h4>{selectedLeaveType ? "Edit Allocate Leaves" : "Allocate Leave"}</h4>
          <p className="mb-0">Fill in the required fields to Create</p>
        </div>
      </div>
      <div className="modal-body custom-modal-body">
        <form>
          <div className="row mb-3">
            <div className="col-12">
              <div className="input-blocks">
                <label>Employee (EPF No - Name)</label>
                <Select
                  size="large"
                  showSearch
                  placeholder="Select Employee"
                  onChange={handleChangeEmployee}
                  value={selectedEmployee || undefined}
                  filterOption={(input, option) => {
                    const text = Array.isArray(option?.children) ? option.children.join('') : option?.children || '';
                    return text.toLowerCase().includes(input.toLowerCase());
                  }}
                  allowClear
                  style={{ width: "100%" }}
                >
                  {Array.isArray(employeeData) && employeeData.length > 0 ? (
                    employeeData.map((emp) => (
                      <Select.Option key={emp._id} value={emp._id} label={`${emp.epf_number} - ${emp.full_name}`} full_name={emp.full_name}>
                        {emp.epf_number} - {emp.full_name}
                      </Select.Option>
                    ))
                  ) : (
                    <Select.Option disabled>No employees available</Select.Option>
                  )}
                </Select>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="input-blocks">
                <label>Employee Type</label>
                <Select
                  value={empType}
                  onChange={setEmpType}
                  className="select"
                  options={employeeTypes}
                  placeholder="Select Employee Type"
                  disabled={!!selectedEmployee}
                  allowClear
                  style={{ width: "100%", height: "40px" }}
                />
              </div>
            </div>
            <div className="col-lg-6">
              <div className="input-blocks">
                <label>Department</label>
                <Select
                  value={selectedDepartment}
                  options={departmentOptions}
                  className="select"
                  placeholder="Select Department"
                  onChange={handleChangeDepartment}
                  allowClear
                  disabled={!!selectedEmployee}
                  style={{ width: "100%", height: "40px" }}
                />
              </div>
            </div>
            <div className="col-12">
              <div className="input-blocks">
                <label>Leave Type</label>
                <Select
                  className="select"
                  options={leaveTypeOptions}
                  placeholder="Select a leave type"
                  value={selectedLeaveTypeOption}
                  onChange={handleChangeLeaveType}
                  style={{ width: "100%", height: "40px" }}
                />
              </div>
            </div>
            <div className="col-12">
              <div className="input-blocks">
                <label>Leave Count</label>
                <input
                  type="number"
                  className="form-control"
                  value={leaveCount}
                  onChange={(e) => setLeaveCount(e.target.value)}
                />
              </div>
              {!selectedLeaveType && (
                <button
                  type="button"
                  className="btn btn-reset"
                  style={{ width: "25%", marginLeft: "auto", display: "block" }}
                  onClick={handleAddToTable}
                >
                  Add
                </button>
              )}
            </div>
          </div>
        </form>

        {addedRows.length > 0 && (
          <Table
            columns={columns}
            dataSource={addedRows}
            rowKey={(record, index) => index}
            pagination={{ pageSize: 5 }}
          />
        )}

        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <button type="button" className="btn btn-cancel" onClick={handleClose}>
            Close
          </button>
          <div>
            <button type="button" className="btn btn-reset me-2" onClick={handleReset}>
              Reset
            </button>
            <button className="btn btn-submit" onClick={selectedLeaveType ? editSaveClick : handleSaveClick}>
              {loading ? <Spin size="small" /> : "Save"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

CreateLeaveTypeModal.propTypes = {
  handleCancel: PropTypes.func.isRequired,
  handleLeaveTypeAdding: PropTypes.func.isRequired,
  selectedLeaveType: PropTypes.object,
};

export default CreateLeaveTypeModal;